export enum MapType {
  ROADMAP = 'roadmap',
  SATELLITE = 'satellite',
}

export interface MapTypeControlProps {
  onClick?: (type: MapType) => void;
}
